export const LARGE = 1
export const SMALL = 2
export const SCALE = 4

export const STATUS_MAP = {
  [LARGE]: { large: true, small: false, full: false, scale: false },
  [SMALL]: { large: false, small: true, full: false, scale: false },
  [SCALE]: { large: false, small: false, full: false, scale: true }
}

export const extractStatuses = status => STATUS_MAP[status]

export default {
  LARGE,
  SMALL,
  SCALE
}



// WEBPACK FOOTER //
// ./src/constants/editorPreviewStatuses.js